/*
 * @Author: Ashley.Liu
 * @Date: 2022-09-01 14:58:36
 * @LastEditTime: 2022-09-01 15:14:46
 * @Description: desc
 */
export function getTwoDimeArray(data, TwoDimeLen) {
  const totalPages = Math.ceil(data.length / TwoDimeLen)
  const lastPageItems = data.length % TwoDimeLen || TwoDimeLen

  const transData = new Array(totalPages)
    .fill()
    .map((e, i) => i)
    .reduce((splitArr, index) => {
      const spliceCount = totalPages - 1 === index ? lastPageItems : TwoDimeLen
      splitArr.push(
        data.slice(index * TwoDimeLen, index * TwoDimeLen + spliceCount)
      )
      return splitArr
    }, [])
  return transData
}
